import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Header, Segment } from 'semantic-ui-react';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';
import { useStore } from '../../../app/stores/store';
import DashboardOnClickedTag from './DashboardOnClickedTag';

export const assetConditionOptions = [
  {
    key: 'Good',
    text: 'Good',
    value: 'Good',
  },
  {
    key: 'Bad',
    text: 'Bad',
    value: 'Bad',
  },
  {
    key: 'OK',
    text: 'OK',
    value: 'OK',
  },
];

function DashboardTagContainer() {
  const { dashboardStore, vaultStore, commonStore } = useStore();
  const { vaultList, getVaultList } = vaultStore;

  useEffect(() => {
    if (vaultList.length === 0) getVaultList();
  }, [vaultList.length, getVaultList]);

  return (
    <div style={{ position: 'relative' }}>
      <Segment
        className={
          dashboardStore.dashboard.onFirstLoadNoTransition
            ? ''
            : dashboardStore.dashboard.setfadeIn
              ? 'fadeIn'
              : 'fadeOut'
        }
        clearing
        style={{
          marginTop: '10px',
          height: '61.7vh',
          overflowY: 'scroll',
        }}
      >
        <Header
          size="huge"
          dividing
          as="h1"
          icon="tag"
          content={
            (userLanguage[0].Level3InventoryRecievingTag?.IRTL01 as any)?.[
              `${commonStore.language.key}`
            ]
          } //"Tag"
          sub
          color="grey"
        />
        <DashboardOnClickedTag />
      </Segment>
    </div>
  );
}

export default observer(DashboardTagContainer);
